var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LegalPage',{attrs:{"title":"Contact Us","intro":"For questions or feedback about this website, use the email address below.","sections":_vm.sections,"email":"contact@gbmodshub.net","page-name":"contact"}})
}
var staticRenderFns = []

export { render, staticRenderFns }